export const AADHAAR_NUMBER_LIST = ["123456789012", "554787508115"];
export const AUTHORIZATION = "authorization";

export const BUTTON_GENERATE_OTP = "Generate OTP";
export const BUTTON_VERIFY_OTP = "Verify OTP";
export const BUTTON_SUBMIT = "Submit";
export const BUTTON_PROCEED = "Proceed";
export const BUTTON_EXPLORE_BENEFITS = "Explore Benefits";
export const BUTTON_NEXT = "Next";
export const BUTTON_CANCEL = "Cancel";
export const BUTTON_CLOSE = "Close";
export const BUTTON_SHARE = "Share";
export const BUTTON_DOWNLOAD = "Download";
export const BUTTON_DOWNLOAD_BI = "Download BI";
export const BUTTON_BACK = "Back";
export const BUTTON_RECALCULATE = "Recalculate";
export const BUTTON_ACCEPT_AND_PROCEED = "Accept & Proceed";
export const BUTTON_CONFIRM_AND_PROCEED = "Confirm & Proceed";
export const BUTTON_DECLINE = "Decline";
export const BUTTON_DECLINE_DECLARATION = "I Decline";
export const BUTTON_CONTACT_AVIVA = "Contact Aviva";
export const BUTTON_START_AGAIN = "Start Again";
export const BUTTON_VERIFY_AND_PROCEED = "Verify & Proceed";
export const BUTTON_START_NEW_JOURNEY = "Start New Journey";
export const BUTTON_DECLINE_JOURNEY = "Decline Journey";
export const BUTTON_RETRY = "Retry Assessment";
export const BUTTON_TERMINATE = "Terminate Journey";

export const CHECKBOX_LABEL_DATA_CONSENT =
  "I consent to override my Do Not Call registration and allow Aviva Life Insurance to contact me via phone, SMS, email, WhatsApp, or other communication methods.";
export const CHECKBOX_LABEL_DATA_CONSENT_SHORT =
  "I consent to override my Do Not Call registration and allow Aviva Life Insurance...";

export const FORMAT_DOB = "DD/MM/YYYY";
export const FORMAT_YYYY_MM_DD = "YYYY-MM-DD";
export const FORMAT_YYYY_MM_DD_HMS = "YYYY-MM-DD HH:mm:ss";
export const FORMAT_DD_MM_YYYY_HMS = "DD-MM-YYYY HH:mm:ss";
export const FORMAT_DD_MM_YYYY = "DD-MM-YYYY";

export const DEFAULT_PRODUCT_SUM_ASSURED = 300000;
export const DEFAULT_PRODUCT_PREMIUM = 999;
export const DEFAULT_AADHAAR_NUMBER = "523456789012";
export const DEFAULT_SAVINGS_PREMIUM_AMOUNT = 1000;
export const DEFAULT_SAVINGS_CORPUS = 181000;
export const DEFAULT_PRODUCT_CATEGORY = "term";
export const DEFAULT_TAB_INDEX = 0;
export const DEFAULT_PREFERRED_LANGUAGE = "english";
export const DEFAULT_AGE = 35;
export const DEFAULT_SAVINGS_PREMIUM_MONTHLY = 1000;
export const DEFAULT_SAVINGS_PREMIUM_YEARLY = 12000;
export const DEFAULT_SAVINGS_SUM_ASSURED = 200000;
export const DAFAULT_POLICY_TERM = "15";
export const DAFAULT_PREMIUM_PAYMENT_TERM = "10";
export const DEFAULT_BANK_MICR_CODE = "123456789";
export const DEFAULT_PARTNER_SLUG = "aviva0001";

export const FIELD_LABEL_MOBILE_NUMBER = "Mobile Number*";

export const FIELD_IFSC_CODE_SUFFIX = "MAHB000";

export const MESSAGE_SEND_OTP = "OTP has been sent to your mobile number";
export const MESSAGE_BMI_OUT_OF_RANGE =
  "Journey terminated due to BMI out of range(18-32).";
export const MESSAGE_DATA_CONSENT = "Data Consent declaration has been sent.";
export const MESSAGE_SEND_AADHAAR_OTP =
  "The OTP has been sent to your Aadhaar-linked mobile number.";
export const MESSAGE_SAVINGS_HEALTH_DECLARATION =
  "I have never suffered from or undergoing any treatment for any cardiovascular, renal, musculoskeletal, neurological, nervous, nephrological, skeletal, respiratory, digestive, uninary, endocrine, lymphatic disorder or cancer and my family, including me, do not have any advers medical history. None of my parent/s or my sibling/s having died before the age 50 due to any adverse chronic ailment. I do not have any habit of smoking or conssumption of alcohol and been advised to quit or under treatment for related diagnosis, nor overweight or underweight as per WHO standards.";
export const MESSGAE_IFRAME_LOADER_CONTENT =
  "Loading calculator, please wait...";

export const NOTE_PREMIUM = "* Excluding GST";
export const NOTE_SUBJECT_TO_MARKET_RISK =
  "* Calculated at the rate of 8% per year";
export const NOTE_SUM_ASSURED =
  "** Earn returns upto including Terminal Bonus @8% of annual return.";

export const PREMIUM_NOTE =
  "* Amount payable is inclusive of GST. Price may vary based on GST.";
export const PRODUCT_SUM_ASSURED_ONE_VALUE = 300000;
export const PRODUCT_SUM_ASSURED_TWO_VALUE = 500000;
export const PRODUCT_SUM_ASSURED_ONE_TITLE = "3 Lacs";
export const PRODUCT_SUM_ASSURED_TWO_TITLE = "5 Lacs";
export const PRODUCT_NAME_TERM = "Aviva Jeevan Suraksha";
export const PRODUCT_NAME_SAVINGS = "Bharat Vikas Parivar Yojana";

export const SAVINGS_PREMIUM_5K_VALUE = 5000;
export const SAVINGS_PREMIUM_10K_VALUE = 10000;
export const SAVINGS_PREMIUM_15K_VALUE = 15000;
export const SAVINGS_PREMIUM_5K_TITLE = "₹5K";
export const SAVINGS_PREMIUM_10K_TITLE = "₹10K";
export const SAVINGS_PREMIUM_15K_TITLE = "₹15K";
export const SAVINGS_ANNUAL_PREMIUM_ONE_VALUE = 12000;
export const SAVINGS_ANNUAL_PREMIUM_TWO_VALUE = 24000;
export const SAVINGS_ANNUAL_PREMIUM_THREE_VALUE = 36000;
export const SAVINGS_ANNUAL_PREMIUM_ONE_TITLE = "₹12K";
export const SAVINGS_ANNUAL_PREMIUM_TWO_TITLE = "₹24K";
export const SAVINGS_ANNUAL_PREMIUM_THREE_TITLE = "₹36K";
export const SAVINGS_MONTHLY_PREMIUM_ONE_VALUE = 1000;
export const SAVINGS_MONTHLY_PREMIUM_TWO_VALUE = 2000;
export const SAVINGS_MONTHLY_PREMIUM_THREE_VALUE = 3000;
export const SAVINGS_MONTHLY_PREMIUM_ONE_TITLE = "₹1K";
export const SAVINGS_MONTHLY_PREMIUM_TWO_TITLE = "₹2K";
export const SAVINGS_MONTHLY_PREMIUM_THREE_TITLE = "₹3K";

export const SLUG_TERM = "term";
export const SLUG_LEAD = "lead";
export const SLUG_PRODUCT = "product";
export const SLUG_OTP = "otp";
export const SLUG_LOGIN = "login";
export const SLUG_YEARLY = "Yearly";
export const SLUG_PREMIUM = "premium";
export const SLUG_CORPUS = "corpus";
export const SLUG_OPEN = "open";
export const SLUG_BACK = "back";
export const SLUG_DOWNLOAD = "download";
export const SLUG_RECALCULATE = "recalculate";
export const SLUG_SHARE = "share";
export const SLUG_SNACK_BAR = "snackbar";
export const SLUG_EN_IN = "en-IN";
export const SLUG_SUM_ASSURED = "sumassured";
export const SLUG_PERFIOS = "PERFIOS";
export const SLUG_GENERATE_OTP = "generateOtp";
export const SLUG_AVAILABLE = "Available";
export const SLUG_NOT_AVAILABLE = "Not Available";
export const SLUG_SAME = "Same";
export const SLUG_DIFFERENT = "Different";
export const SLUG_SAVINGS = "Savings";
export const SLUG_PARTNER_SUREPASS = "SUREPASS";
export const SLUG_RETRY = "retry";
export const SLUG_TERMINATE = "terminate";
export const SLUG_NONPOS = "NONPOS";
export const SLUG_POS = "POS";
export const SLUG_TAB_SAVINGS = "SAVINGS";
export const SLUG_TAB_TERM = "TERM";
export const SLUG_SELF_EMPLOYED = "Self Employed";
export const SLUG_SELF_HYPHEN_EMPLOYED = "Self-Employed";
export const SLUG_EDUCATION_10TH = "10th";
export const SLUG_TERM_PRODUCT = "signature-3d";
export const SLUG_EKYC_PARTNER = "ekycPartner";
export const SLUG_CALCULATOR_CONFIG = "calculatorConfig";
export const SLUG_TROP_PRODUCT = "smart-trop";
export const SLUG_DEDUPE = "DEDUPE";
export const SLUG_EXISTING_POLICIES = "EXISTINGPOLICIES";

export const SLUG_PLAN_OPTION_A = "Premium you pay";
export const SLUG_PLAN_OPTION_B = "Amount you get";
export const SUM_ASSURED_5L_PRODUCT_PREMIUM = 1599;

export const TITLE_PLAN_OPTION_A = "Premium Amount Paid";
export const TITLE_PLAN_OPTION_B = "Maturity Amount Received";
export const TITLE_LOGIN = "Login Via Mobile Number";

export const DEFAULT_PARTNER_CODE = "aviva0001";
export const AVIVA_PARTNER_CODE = "aviva0002";
export const DBGB_PARTNER_CODE = "aviva0003";
export const TERM_PARTNER_CODE = "aviva0004";

export const EXCLUSIVE_AVAILABLE_BANNERS_FOR_PARTNER = [
  DEFAULT_PARTNER_CODE,
  DBGB_PARTNER_CODE,
];
